import axios from 'axios';
import { getApiUrl } from '@/config/api';
import authService from '@/shared/services/auth';

export default class CatProyectoService {
  constructor() {
    this.proyectos = [];
    this.loading = false;
    this.error = null;
    this.sortField = null;
    this.sortDirection = 'asc';
    this.currentPage = 1;
    this.itemsPerPage = 10;
    this.selectedEmpresa = null;
  }

  // Inicializar el servicio
  async initialize() {
    await this.waitForEmpresa();
    await this.listar();
  }

  async waitForEmpresa() {
    return new Promise((resolve) => {
      const checkEmpresa = () => {
        this.selectedEmpresa = authService.getSelectedEmpresa();
        if (this.selectedEmpresa && this.selectedEmpresa.EmpresaId) {
          console.log('Empresa encontrada para CatProyecto:', this.selectedEmpresa);
          resolve();
        } else {
          setTimeout(checkEmpresa, 100);
        }
      };
      checkEmpresa();
    });
  }

  // Listar proyectos
  async listar() {
    this.loading = true;
    this.error = null;

    console.log('Cargando proyectos de CatProyecto...');
    
    try {
      const token = authService.getToken();
      if (!token) {
        throw new Error('No hay token de autenticación');
      }
      if (!this.selectedEmpresa || !this.selectedEmpresa.EmpresaId) {
        this.loading = false;
        return { success: false, data: [], message: 'Debe elegir una empresa antes de poder continuar.' };
      }

      const response = await axios.post(getApiUrl('/api/CatProyecto/listar'), {
        EmpresaId: this.selectedEmpresa.EmpresaId
      }, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      
      // Filtrar por empresa en el frontend como medida de seguridad adicional
      const allProyectos = response.data || [];
      this.proyectos = allProyectos.filter(proyecto => proyecto.EmpresaId === this.selectedEmpresa.EmpresaId);
      this.loading = false;
      
      console.log('Proyectos cargados:', this.proyectos.length, 'de', allProyectos.length, 'total');
      console.log('Empresa del usuario:', this.selectedEmpresa.EmpresaId);
      this.loading = false;
      
      return {
        success: true,
        data: this.proyectos,
        message: 'Proyectos cargados exitosamente'
      };
    } catch (error) {
      console.error('Error al cargar proyectos:', error);
      this.error = error?.response?.data?.message || 'No se pudieron cargar los proyectos. Por favor, intente nuevamente.';
      this.loading = false;
      throw error;
    }
  }

  // Guardar proyecto (insert/update)
  async guardar(proyecto) {
    try {
      console.log('Guardando proyecto:', proyecto);
      
      const token = authService.getToken();
      if (!token) {
        throw new Error('No hay token de autenticación');
      }

      // Asegurar que tenga EmpresaId
      if (!proyecto.EmpresaId && this.selectedEmpresa) {
        proyecto.EmpresaId = this.selectedEmpresa.EmpresaId;
      }

      const response = await axios.post(getApiUrl('/api/CatProyecto/guardar'), proyecto, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      // Recargar la lista después de guardar
      await this.listar();
      
      return {
        success: true,
        data: response.data,
        message: proyecto.Clave && proyecto.Clave !== '' ? 'Proyecto actualizado exitosamente' : 'Proyecto creado exitosamente'
      };
    } catch (error) {
      console.error('Error al guardar proyecto:', error);
      throw error;
    }
  }

  // Leer un proyecto específico
  async lectura(clave, empresaId) {
    try {
      console.log('Leyendo proyecto:', clave, empresaId);
      
      const token = authService.getToken();
      if (!token) {
        throw new Error('No hay token de autenticación');
      }

      const response = await axios.post(getApiUrl('/api/CatProyecto/lectura'), {
        Clave: clave,
        EmpresaId: empresaId || (this.selectedEmpresa ? this.selectedEmpresa.EmpresaId : 0)
      }, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      return {
        success: true,
        data: response.data,
        message: 'Proyecto encontrado'
      };
    } catch (error) {
      console.error('Error al leer proyecto:', error);
      throw error;
    }
  }

  // Borrar proyecto
  async borrar(clave, empresaId) {
    try {
      console.log('Eliminando proyecto:', clave, empresaId);
      
      const token = authService.getToken();
      if (!token) {
        throw new Error('No hay token de autenticación');
      }

      const response = await axios.post(getApiUrl('/api/CatProyecto/borrar'), {
        Clave: clave,
        EmpresaId: empresaId || (this.selectedEmpresa ? this.selectedEmpresa.EmpresaId : 0)
      }, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      // Recargar la lista después de eliminar
      await this.listar();
      
      return {
        success: true,
        data: response.data,
        message: 'Proyecto eliminado exitosamente'
      };
    } catch (error) {
      console.error('Error al eliminar proyecto:', error);
      throw error;
    }
  }

  // Recargar proyectos
  async recargar() {
    console.log('Recargando proyectos...');
    await this.listar();
  }

  // Descargar proyectos
  async downloadBulk() {
    try {
      console.log('Descargando proyectos...');
      
      const token = authService.getToken();
      if (!token) {
        throw new Error('No hay token de autenticación');
      }

      const response = await axios.post(getApiUrl('/api/CatProyecto/descargar'), {
        EmpresaId: this.selectedEmpresa ? this.selectedEmpresa.EmpresaId : 0
      }, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        responseType: 'blob'
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'proyectos.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      
      return {
        success: true,
        message: 'Descarga iniciada'
      };
    } catch (error) {
      console.error('Error al descargar proyectos:', error);
      throw error;
    }
  }

  // Ordenar datos
  sort(field) {
    if (this.sortField === field) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortField = field;
      this.sortDirection = 'asc';
    }
  }

  // Obtener datos ordenados
  get sortedData() {
    if (!this.sortField) return this.proyectos;
    
    return [...this.proyectos].sort((a, b) => {
      let aVal = a[this.sortField];
      let bVal = b[this.sortField];
      
      // Manejar fechas
      if (this.sortField === 'FechaInicio' || this.sortField === 'FechaFin') {
        aVal = new Date(aVal);
        bVal = new Date(bVal);
      }
      
      // Manejar números
      if (typeof aVal === 'number' && typeof bVal === 'number') {
        return this.sortDirection === 'asc' ? aVal - bVal : bVal - aVal;
      }
      
      // Manejar strings
      if (typeof aVal === 'string' && typeof bVal === 'string') {
        return this.sortDirection === 'asc' 
          ? aVal.localeCompare(bVal)
          : bVal.localeCompare(aVal);
      }
      
      // Manejar fechas
      if (aVal instanceof Date && bVal instanceof Date) {
        return this.sortDirection === 'asc' ? aVal - bVal : bVal - aVal;
      }
      
      return 0;
    });
  }

  // Obtener datos paginados
  get paginatedData() {
    const sorted = this.sortedData;
    const start = (this.currentPage - 1) * this.itemsPerPage;
    const end = start + this.itemsPerPage;
    return sorted.slice(start, end);
  }

  // Obtener total de páginas
  get totalPages() {
    return Math.ceil(this.proyectos.length / this.itemsPerPage);
  }

  // Obtener icono de ordenamiento
  sortIcon(field) {
    if (this.sortField !== field) return 'bi bi-arrow-down-up';
    return this.sortDirection === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down';
  }

  // Cambiar página
  changePage(page) {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
    }
  }
}
